import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "holiday-premium-detail-modal" }
const _hoisted_2 = { class: "holiday-premium-detail-modal__head" }
const _hoisted_3 = { class: "holiday-premium-detail-modal__body" }
const _hoisted_4 = {
  key: 0,
  class: "holiday-premium-detail-modal__empty"
}
const _hoisted_5 = {
  key: 1,
  class: "holiday-premium-detail-modal__table-wrap"
}
const _hoisted_6 = { class: "holiday-premium-detail-modal__table" }
const _hoisted_7 = { class: "center" }
const _hoisted_8 = { class: "center" }
const _hoisted_9 = { class: "right" }
const _hoisted_10 = { class: "holiday-premium-detail-modal__footer" }

import LoadingOverlay from '@/components/common/LoadingOverlay.vue';
import type { HomeWageHolidayPremiumDetailRow } from '@/policies';


export default /*@__PURE__*/_defineComponent({
  __name: 'HomeWageHolidayPremiumDetailModal',
  props: {
    modelValue: { type: Boolean },
    loading: { type: Boolean },
    rows: {}
  },
  emits: ["update:modelValue", "close"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    "model-value": __props.modelValue,
    "max-width": "640",
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (emit('update:modelValue', $event)))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("header", _hoisted_2, [
          _cache[4] || (_cache[4] = _createElementVNode("h3", { class: "holiday-premium-detail-modal__title" }, "휴일수당 근무 내역", -1)),
          _createElementVNode("button", {
            type: "button",
            class: "holiday-premium-detail-modal__close",
            "aria-label": "닫기",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('close')))
          }, [
            _createVNode(_component_v_icon, { size: "18" }, {
              default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                _createTextVNode("mdi-close", -1)
              ]))]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(LoadingOverlay, {
            show: __props.loading,
            text: "불러오는 중..."
          }, null, 8, ["show"]),
          (!__props.loading && __props.rows.length === 0)
            ? (_openBlock(), _createElementBlock("p", _hoisted_4, " 휴일수당 대상 청구 건이 없습니다. "))
            : (!__props.loading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("table", _hoisted_6, [
                    _cache[5] || (_cache[5] = _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", null, "일자"),
                        _createElementVNode("th", null, "수급자"),
                        _createElementVNode("th", null, "plan 시간"),
                        _createElementVNode("th", { class: "right" }, "시간"),
                        _createElementVNode("th", null, "사유")
                      ])
                    ], -1)),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.rows, (row, idx) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: `${row.date}|${row.recipientName}|${idx}`
                        }, [
                          _createElementVNode("td", _hoisted_7, _toDisplayString(row.date), 1),
                          _createElementVNode("td", null, _toDisplayString(row.recipientName || '-'), 1),
                          _createElementVNode("td", _hoisted_8, _toDisplayString(row.planTime), 1),
                          _createElementVNode("td", _hoisted_9, _toDisplayString(row.hours) + "h", 1),
                          _createElementVNode("td", null, _toDisplayString(row.reason), 1)
                        ]))
                      }), 128))
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
        ]),
        _createElementVNode("footer", _hoisted_10, [
          _createVNode(_component_v_btn, {
            variant: "text",
            class: "btn-close",
            size: "small",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('close')))
          }, {
            default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
              _createTextVNode("닫기", -1)
            ]))]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})